import {
  useGetOrganizationConfigQuery,
  useUploadOrgLogoMutation,
} from "@/src/services/organization/organization.hooks";
import { useTheme } from "@/src/styles/theme-provider";
import { pickMedia } from "@/src/utils/picker-utils";
import { Gallery } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { ActivityIndicator, Image, Pressable, Text, View } from "react-native";

const OrgLogoSection = () => {
  const { t } = useTranslation();
  const { primaryPalette } = useTheme();

  const { data: orgConfig } = useGetOrganizationConfigQuery();
  const { mutateAsync: uploadOrgLogo, isPending: isUploading } =
    useUploadOrgLogoMutation();

  const currentLogo = orgConfig?.orgLogo;

  const handlePickOrgLogo = async () => {
    const assets = await pickMedia();
    if (!assets || assets.length === 0) return;
    const asset = assets[0];

    await uploadOrgLogo({
      uri: asset.uri,
      fileName: asset.fileName ?? `org_logo_${Date.now()}.jpg`,
      mimeType: asset.mimeType ?? "image/jpeg",
      existingConfigId: orgConfig?.OrganizationId,
    });
  };

  return (
    <View>
      <Text className="text-onyx font-medium text-base px-2 pb-2">
        {t("LABEL_ORG_LOGO")}
      </Text>
      <View className="flex-col p-4 gap-4">
        <View className="flex-col sm:flex-row gap-4 items-stretch sm:items-start">
          {/* Upload zone */}
          <Pressable
            onPress={handlePickOrgLogo}
            disabled={isUploading}
            className="flex-1 min-h-[120px] border-2 border-dashed border-ash-3 rounded-2xl items-center justify-center gap-3 p-6 bg-obsidian active:opacity-70 hover:bg-ash-3"
          >
            {isUploading ? (
              <>
                <ActivityIndicator color={primaryPalette.default} />
                <Text className="text-sm text-ash-2">
                  {t("LABEL_UPLOADING")}
                </Text>
              </>
            ) : (
              <>
                <View className="w-12 h-12 rounded-full items-center justify-center bg-primary-2">
                  <Gallery size={24} color={primaryPalette.default} />
                </View>
                <Text className="text-sm font-semibold text-onyx">
                  {t("BTN_UPLOAD_LOGO")}
                </Text>
              </>
            )}
          </Pressable>

          {/* Current logo preview */}
          <View className="flex-1 gap-2">
            <View className="border border-ash-3 rounded-2xl bg-obsidian items-center justify-center min-h-[160px]">
              {currentLogo ? (
                <Image
                  source={{ uri: currentLogo }}
                  resizeMode="contain"
                  style={{ width: "100%", height: 100 }}
                />
              ) : (
                <View className="items-center gap-2">
                  <View className="w-12 h-12 rounded-full bg-ash items-center justify-center">
                    <Gallery size={22} color={primaryPalette[1]} />
                  </View>
                  <Text className="text-xs text-ash-2">
                    {t("LABEL_NO_LOGO_YET")}
                  </Text>
                </View>
              )}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default OrgLogoSection;
